import React from "react";
import DashboardShellBase from "../../pages/SHARED/components/DashboardShellBase";

const LawFirmDashboard = (props) => <DashboardShellBase {...props} variant="lawFirm" />;

export default LawFirmDashboard;
